<template>
  <div name="evidenceGrid" class="-mx-3 -mt-4 pb-10 pt-4">

    <section v-if="errored" class="w-full text-center mt-2">
      <h3 class="font-bold text-xl text-action-red">
        There was an issue moving the evidence details.
      </h3>
      <p class="text-action-blue">
        Please try again shortly or contact us to resolve the issue.
      </p>
    </section>

    <transition name="fade">
      <div class="loading" v-show="isSaving">
        <span class="fa fa-spinner fa-spin"></span> Saving
      </div>
    </transition>

    <div
        class="
          px-auto
          grid grid-cols-5
          gap-2 gap-y-2
          bg-white
          pb-6
          mt-4
          w-full
        "
      >
        <div
       
          class="w-32 h-20 bg-blue-200"
          v-for="item in filteredEvidences"
          :key="item.identifier"
        >
<div
@click="deleteEvidence(item)"
class="text-3xl text-red-500 cursor-pointer hover:opacity-50">
  <i class="fas fa-times-circle absolute -mr-6"></i>
</div>
        <evidencevideo
              v-if="item.media_type === 'video'"
              reference="'ref_'+index"
              :url="loadFile(item.media_url)"
              width="100%"
              height="100%"
              class="overflow-hidden"
              style="max-height: 110px !important"
            ></evidencevideo>
            <evidenceimage
              v-else
              :url="loadFile(item.media_url)"
              reference="'ref_'+index"
              class="overflow-hidden"
              style="max-height: 110px !important"
            ></evidenceimage>

          <!-- <div  @click="selectEvidence(item)"
          class="rounded overflow-hidden shadow-xl cursor-pointer bg-red-200 "
          >
          
          </div> -->
        </div>
      </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { EvidenceService } from "@/services/evidence.service";
import { fileEvidenceMixin } from "@/mixins/file-EvidenceMixin.js";

const evidenceimage = () => import("@/components/evidence/EvidenceImage.vue");
const evidencevideo = () => import("@/components/evidence/EvidenceVideo.vue");

export default {
  name: "evidenceGrid",
  mixins: [fileEvidenceMixin],
  components: {
    evidenceimage,
    evidencevideo
  },
  props: {
    evidences: { type: Array, required: true },
    allowDelete: { type: Boolean, required: false, default: false },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    filteredEvidences() {
      return this.evidences
    },
    
  },
  data() {
    return {
      errored: false,
      loading: false,
      folder: "",
      selectedEvidences: [],
    };
  },
  created() {
    this.folder = this.wordNumericValue(this.currentUser.schoolID);
  },
  methods: {
    loadFile(path) {
      return this.folder + "/" + path;
    },
    selectEvidence(evidence) {

    },
    deleteEvidence(evidence) {
      this.$emit("deletedEvidence", evidence);
    }
  }
  
};
</script>

<style scoped>

</style>
